<template>
  <div class="login-wrapper">
    <v-form id="reset-password-form" @submit.prevent="resetPassword" class="login px-5 py-3">
      <v-img max-width="250" v-show="$vuetify.breakpoint.mdAndUp" src="/img/veroFresh.png" />
      <div v-if="passwordResetSuccess" id="password-reset-success" class="my-2 login">
        <div class="py-1 mt-4">{{ $t('password_reset_success') }}</div>
        <v-btn id="login-button" :to='`/login?email=${loginForwardEmail}`' class="w-100 mx-auto my-2">
          <v-icon>mdi-login</v-icon>
          {{ $t('log_in') }}
        </v-btn>
      </div>
      <div v-else class="mb-3 login">
        <password-change-form
          ref="password-change-form"
          layout="vertical"
          :password.sync="password"
          :passwordHelpText="$t('password_info_reset')"/>
        <div v-if="errorMessage" class="login-error py-1">
          {{ errorMessage }}
        </div>
        <v-btn type="submit" class="w-100 mx-auto my-2">
          <v-icon>mdi-login</v-icon>
          {{ $t('reset_password') }}
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import PasswordChangeForm from '@/components/shared/PasswordChangeForm'
import AuthUtil from '@/util/AuthUtil'

export default {
  name: 'ResetPassword',
  components: {PasswordChangeForm},
  data() {
    return {
      // the password
      password: null,
      // Whether we are currently sending the reset password request
      sendingResetPassword: null,
      // Contains any error messages to be displayed
      errorMessage: null,
      // Flag for whether the password has been reset successfully
      passwordResetSuccess: false,
      // The email to pass along to the login page, used to pre-populate the login form
      loginForwardEmail: null
    }
  },
  created() {
    // Fire off a quick API check to see if we're in maintenance mode. If we get a 503,
    // the interceptor will turn maintenance mode on.
    this.$httpAdapter({url: 'site/status'})
  },
  methods: {
    async resetPassword() {
      this.errorMessage = null

      const passwordValid = this.$refs['password-change-form'].validate()
      if (!passwordValid) {
        return false
      }

      this.sendingResetPassword = true

      const response =
        await AuthUtil.resetPassword(this.password, this.$route.query.token)
          .catch(err => err.response)
          .finally(() => {
            this.sendingResetPassword = false
          })

      if (response.status === 422) {
        if (response.data.message === 'Invalid Token') {
          this.errorMessage = this.$i18n.t('password_reset_token_invalid')
        } else {
          this.errorMessage = this.$i18n.t('password_reset_invalid')
        }
      } else if (response.status === 200) {
        this.passwordResetSuccess = true
        if (response.data) {
          // Set the email we will use on the login page
          this.loginForwardEmail = response.data.email
        }
      } else {
        this.errorMessage = this.$i18n.t('password_reset_generic_error')
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
